var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlay7 = function SvgIconPlay7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "m29.008 32.284-7.561 4.284V19.431l7.561 4.285L36.569 28l-7.561 4.284zM47.341 0H8.658C3.896 0 0 3.896 0 8.659v38.682C0 52.103 3.896 56 8.658 56h38.683C52.103 56 56 52.103 56 47.341V8.659C56 3.896 52.103 0 47.341 0z"
  })));
};
export default SvgIconPlay7;